<template>
  <div class="bg-gray-200">
    <div class="container mx-auto grid grid-cols-2 w-full">
      <div class="py-2 text-md">
        <router-link to="/" class="text-green hover:underline">Dashboard</router-link>
        <span class="text-gray-400"> / </span>
        <router-link to="/quotes" class="text-green hover:underline">Quote Requests</router-link>
        <span class="text-gray-400"> / </span>
        <span class="font-bold">Create</span>
      </div>
    </div>
  </div>
  <div class="container mx-auto py-5">
    <div v-if="error" class="bg-red-700 text-white font-bold px-3 py-2 mb-5">{{error}}</div>
    <form @submit.prevent="submit" v-if="!success">
      <h2 class="text-3xl font-bold">Create Quote Request</h2>
      <div class="flex w-full">
        <div class="mb-5 mr-10">
          <label class="text-sm block my-2 font-bold">Name</label>
          <input class="text-sm p-2 w-80 shadow focus:outline-none focus:ring focus:ring-green-400" type="text" v-model="form.name" required>
        </div>
        <div class="mb-5">
          <label class="text-sm block my-2 font-bold">Customer</label>
          <input class="text-sm p-2 w-80 shadow focus:outline-none focus:ring focus:ring-green-400" type="text" v-model="form.customer" required>
        </div>
      </div>
      <div class="mb-5">
        <label class="text-sm block my-2 font-bold">Notes</label>
        <textarea class="text-sm mt-2 w-1/2 p-2 shadow" v-model="form.notes" rows="4"></textarea>
      </div>
      <h2 class="text-3xl font-bold mt-10">Parts <PlusCircleIcon class="ml-2 inline-block h-7 w-7 text-green cursor-pointer" v-on:click="addPart()" /></h2>
      <div class="flex bg-gray-50 mt-2" v-for="(part, index) in form.parts" v-bind:key="index">
        <div class="mb-5 mr-10 ml-5">
          <label class="text-sm block my-2 font-bold">Part Number</label>
          <input class="text-sm p-2 w-80 shadow focus:outline-none focus:ring focus:ring-green-400" type="text" v-model="part.part_number">
        </div>
        <div class="mb-5 mr-10 ml-5">
          <label class="text-sm block my-2 font-bold">Quantity</label>
          <input class="text-sm p-2 w-80 shadow focus:outline-none focus:ring focus:ring-green-400" type="text" v-model="part.quantity">
        </div>
      </div>

      <hr class="block my-5">
      <button class="bg-green w-80 rounded-md text-white p-1 shadow mt-5" type="submit">Create Quote Request</button>
    </form>
    <div v-if="success">Your quote request has been emailed successfully! Please wait for us to review it and get a quote back to you.</div>
  </div>
</template>
<script>
import { PlusCircleIcon } from "@heroicons/vue/outline";
import { mapGetters } from "vuex";

export default {
  components: {
    PlusCircleIcon,
  },

  data: () => {
    return {
      form: {
        name: "",
        parts: [
          {
            part_number: "",
          },
        ],
      },
      error: "",
      success: false,
    };
  },

  computed: {
    ...mapGetters({
      quote: "quotes/details",
    }),
  },

  methods: {
    async submit() {
      if (!this.form.parts[0].part_number) {
        this.error = "Must have at least one part number";
        return;
      }
      try {
        await this.$store.dispatch("quotes/create", this.form);

        this.success = true;
        this.error = "";
      } catch (error) {
        this.error = "Error from API";
      }
    },
    addPart() {
      this.form.parts.push({
        part_number: "",
      });
    },
  },
};
</script>